export default __webpack_public_path__ + "static/cvonkries-d6f23bd5a0e00d29c51de5f7e998b251.jpg";